import { AlertService, AuthService } from "@standard/services";
import { TriggerAPI } from "api";
import { USER_ROLE } from "data/constants";

export default function GeneralSetting({ setIsLoading }) {
  const user = AuthService.getCurrentUser();

  return (
    <div>
      {user.roles.includes(USER_ROLE.SUPERADMIN) && (
        <div className="row">
          <div className="col-12">
            <button
              className="btn btn-danger btn-block"
              type="button"
              onClick={() => {
                AlertService.confirm("Do you want to call trigger ?").then(
                  (res) => {
                    if (res === true) {
                      setIsLoading(true);
                      TriggerAPI.trigger()
                        .then(() => {
                          AlertService.done("Trigger success").then(() => {
                            setIsLoading(false);
                          });
                        })
                        .catch((error) => AlertService.error(error.message));
                    }
                  }
                );
              }}
            >
              Call Trigger API
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
